/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow } from "@mui/material";
import moment from "moment";
import React from "react";
import tableStyle from "../../theme/styles/table";
import { getGohonzonType } from "../../utils";
import { isEmptyObj } from "../../utils/helper";
import Button from "../common/Button";
import { style } from "./styles";

function GohonzonCancellation({ member, onHandoverApplication }) {
  if (isEmptyObj(member) || isEmptyObj(member.memberDetails)) {
    return null;
  }
  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {member.memberId || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.memberDetails.fullName || "-"}
        <br />
        {member.memberDetails.addressLine1 || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.memberDetails.mobileNumber || "-"}
        <br />
        {member.memberDetails.emailId || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.memberDetails.divisionName || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.memberDetails.regionName || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {getGohonzonType(member.gohonzonType)}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.requestedBy || "-"}
        <br />
        on:{" "}
        {/* {member.createdAt !== null ? moment(member.createdAt).format("L") : "-"} */}
        {member.createdAt ? moment(member.createdAt).format("DD/MM/YYYY") : "-"}
      </TableCell>
      <TableCell style={{ ...style.Cell }}>
        {/* <Box style={style.status}>Cancellation Requested</Box> */}
        {member.id || "-"}
      </TableCell>
      {/* <TableCell style={{ ...style.Cell }}>{member.gohonzon}</TableCell> */}
      <TableCell style={{ color: "#8C8C8C" }}>
        <Box style={style.flexC}>
          <Button
            variant="outlined"
            onClick={() => onHandoverApplication(member)}
            style={{ ...style.actionBtn, width: "100px" }}
            label="CANCEL"
          />
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default GohonzonCancellation;
